import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _fa6d277c = () => interopDefault(import('../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _5df6a3de = () => interopDefault(import('../pages/voting.vue' /* webpackChunkName: "pages/voting" */))
const _1a3d7dcc = () => interopDefault(import('../pages/winners.vue' /* webpackChunkName: "pages/winners" */))
const _96e927ae = () => interopDefault(import('../pages/awards/ceo-voting/index.vue' /* webpackChunkName: "pages/awards/ceo-voting/index" */))
const _ba03e03e = () => interopDefault(import('../pages/auth/google/callback/index.vue' /* webpackChunkName: "pages/auth/google/callback/index" */))
const _0aaf1cda = () => interopDefault(import('../pages/awards/ceo-voting/thank-you.vue' /* webpackChunkName: "pages/awards/ceo-voting/thank-you" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/thank-you/",
    component: _fa6d277c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you"
  }, {
    path: "/voting/",
    component: _5df6a3de,
    pathToRegexpOptions: {"strict":true},
    name: "voting"
  }, {
    path: "/winners/",
    component: _1a3d7dcc,
    pathToRegexpOptions: {"strict":true},
    name: "winners"
  }, {
    path: "/awards/ceo-voting/",
    component: _96e927ae,
    pathToRegexpOptions: {"strict":true},
    name: "awards-ceo-voting"
  }, {
    path: "/auth/google/callback/",
    component: _ba03e03e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-google-callback"
  }, {
    path: "/awards/ceo-voting/thank-you/",
    component: _0aaf1cda,
    pathToRegexpOptions: {"strict":true},
    name: "awards-ceo-voting-thank-you"
  }, {
    path: "/",
    component: _2dfb1658,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
